// extracted by mini-css-extract-plugin
export var backdropBlur = "_77-0";
export var body = "_77-5";
export var bodyScroll = "_77-6";
export var columnFooter = "_77-7";
export var columnFooterFlush = "_77-8";
export var contentColumn = "_77-4";
export var frame = "_77-3";
export var heroContent = "_77-c";
export var heroOverlay = "_77-b";
export var image = "_77-a";
export var imageWrapper = "_77-9";
export var modal = "_77-1";
export var modalMain = "_77-2";
export var productHeader = "_77-d";
export var productHeaderIcon = "_77-e";
export var productHeaderName = "_77-f";
export var progressIndicator = "_77-g";